/* eslint-disable no-unused-vars */
/* global G */
import { asyncPipeSpread, setKey } from 'lib/util'
import find, { Components } from 'lib/sequence/component/children/find'
import sequenceComponentState from 'lib/sequence/component/state'

const {
  set: activate,
} = sequenceComponentState('active')

/**
 * Presets a possible sensor key passed through `args` as the sensor model's key.
 *
 * @param module current module composition
 */
const presetSensorKey = (module: Gaia.AppModule.Spec) => (components: Components, ...args: any[]) => {
  const { key } = args[0]
  const { sensor } = module[G.MODEL][G.CHILDREN]

  setKey(key, G.REF, sensor[G.STATE])

  return [components, ...args]
}

/**
 * Activates the camera.
 *
 * @param components find components proxy
 * @param args       action arguments
 */
const activateCamera = (components: Components, ...args: any[]) => {
  const { camera } = components
  activate(camera)
  return args
}

/**
 * Camera Action
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 */
export default (module: Gaia.AppModule.Spec) =>
  (component: Gaia.Component.Spec) =>
    async (...args: any[]) =>
      asyncPipeSpread(
        presetSensorKey(module),
        activateCamera,
      )(find(component), ...args)
